import Parse from "parse";

//Parse.initialize("siautomation");
//Parse.serverURL = "https://siautomation.openinc.de/parse";

Parse.initialize("openinc-demo");
Parse.serverURL = "https://parse-demo.apps.openinc.dev/parse";
